import { useContext } from 'react';

import { AuthContext } from '@/components/auth/authWrapper';
import { AuthContextVal } from '@/types/auth';


export function useAuthContext(): AuthContextVal {
  const context = useContext( AuthContext );

  if ( !context.isReady ) {
    // Throw to suspend (requires Suspense boundary)
    throw new Promise( resolve => {
      const interval = setInterval(
        () => {
          if ( context.isReady ) {
            clearInterval( interval );
            resolve( context );
          }
        }, 50 );
    } );
  }

  return context;
}